import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { DEPARTMENT_MODEL, MEAL_TIME_MODEL, MENU_MODEL, TO_CLONE_ARRAYS } from '../Model/Model';
import HandleChange from './../../../../../Helpers/HandleChange';
import {
    CreateMenu,
    DeleteDepartmentById,
    DeleteMealTimeById,
    DeleteUserById,
    GetAllCourseType,
    GetAllItem,
    GetAllMeals,
    GetMenuById,
    UpdateMenu,
} from '../../../../../reduxToolkit/FoodieMenu/MenuApi';
import { toast } from 'react-toastify';
import { GetAllCafeterias } from '../../../../../reduxToolkit/FoodieShift/FoodieShiftApi';
import { errorMsg, formatTimeUnit, DECIMAL_REGEX } from '../../../../../Apis/functions';
import { toMilitaryHour } from '../../../../../utils/TimeConversion';
import { permissionObj } from '../../../../../Helpers/permission';
import routes from '../../../../../Routes/routes';
import { GetFirstFoodieSetting } from '../../../../../reduxToolkit/Foodie/FoodieApi';
import {
    GetDepartmentsByCafeteriaId,
    GetUsersByCafeteriaId,
} from '../../../../../reduxToolkit/FoodieCafeteria/CafeteriaApi';
import { GetAllMealtimes } from '../../../../../reduxToolkit/FoodieOrders/FoodieOrdersApi';
import {MIN_MEAL_COST} from "../../Manage/Models/Model";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const UpdateMenuApp = ({ disabled }) => {
    const { id } = useParams();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const { allCourseType } = useSelector((state) => state.MenuSlice);
    const { allMeals } = useSelector((state) => state.MenuSlice);
    const { allCafeterias } = useSelector((state) => state.FoodieShiftSlice);
    const { allItem } = useSelector((state) => state.MenuSlice);
    const { getFirstFoodieSetting: costInfo } = useSelector((state) => state.employeeFoodieSlice);
    const rawMealTimes = useSelector((state) => state.FoodieOrdersSlice.mealtimes);
    const allMealTimes = Array.isArray(rawMealTimes) ? rawMealTimes.map(({ id, name }) => ({ id, label: name })) : [];
    const location = useLocation();
    let { state } = location;
    let cloneId = state?.cloneId;
    disabled = disabled || (!DEV && !permission?.includes(permissionObj.WEB_FOODIE_MENU_UPDATE) && !permission?.includes(permissionObj.WEB_FOODIE_MENU_CLONE));
    const [emptyDepartment, setEmptyDepartment] = useState(false);
    const [emptyMealTime, setEmptyMealTime] = useState(false);
    const [emptyFields, setEmptyFields] = useState(false);
    const [selectedDepartment, setSelectedDepartment] = useState([]);
    const [selectedName, setSelectedName] = useState([]);
    const [item, setItem] = useState({ ...MENU_MODEL });
    const [selectedMealTime, setSelectedMealTime] = useState([]);
    const [deleteItem, setDeleteItem] = useState(false);
    const [updateItem, setUpdateItem] = useState(false);
    const [dataComplete, setDataComplete] = useState(false);
    const [department, setDepartment] = useState(DEPARTMENT_MODEL);
    const [mealTime, setMealTime] = useState(MEAL_TIME_MODEL);
    const { handleChange } = HandleChange({ model: item, setModel: setItem });
    const [isServingDateValid, setIsServingDateValid] = useState(true);
    const [update, setUpdate] = useState(false);
    const { getDepartmentsByCafeteriaId } = useSelector((state) => state.CafeteriaSlice);
    const { getUsersByCafeteriaId } = useSelector((state) => state.CafeteriaSlice);
    const [isValidCost, setIsValidCost] = useState(true);
    const [isValidCostText, setIsValidCostText] = useState('this_value_must_be_greater_than_0');
    const showCostInfo =  costInfo?.isBaseCost === false && costInfo?.isMealTimeCost === false;

    useEffect(() => {
        if (!update) return;

        let notSelected = false;
        let notAdded = false;

        const { oneFilledAndOneEmpty, showToast } = department.validate({
            selectedDepartment,
            setNotSelected: (value) => (notSelected = value),
            setNotAdded: (value) => (notAdded = value),
        });

        const { item, unit } = department;
        const bothEmpty = !item && !unit;

        if (bothEmpty) {
            setEmptyDepartment(false);
        } else if (oneFilledAndOneEmpty) {
            setEmptyDepartment(true);
        } else {
            setEmptyDepartment(false);
        }
        if (showToast) {
            toast.warn(t('click_to_add'));
        }
        if (selectedDepartment.length > 0) {
            setDepartment({ ...DEPARTMENT_MODEL });
        }
        setUpdate(false);
    }, [update, selectedDepartment]);

   useEffect(() => {
    if (!update) return;

    mealTime.updateState({ selectedMealTime, setEmptyMealTime, setMealTime, setUpdate, toast, t });
}, [update, selectedMealTime]);


    //validate id cafeteria serving date is valid
    useEffect(() => {
        if (item.cafeteriaServingDate && item.releaseDate) {
            setIsServingDateValid(
                new Date(item.cafeteriaServingDate) >= new Date(item.releaseDate)
            );
        }
    }, [item.cafeteriaServingDate, item.releaseDate]);

    // Load all required static data on component mount
    useEffect(() => {
        dispatch(GetAllCourseType());
        dispatch(GetAllMeals());
        dispatch(GetAllMealtimes());
        dispatch(GetFirstFoodieSetting())
        dispatch(GetAllItem());
        dispatch(GetAllCafeterias());
    }, []);

    useEffect(() => {
        if(item.diner){
            setItem((prev) => prev.clearDependencies());
            dispatch(GetDepartmentsByCafeteriaId(item.diner));
            dispatch(GetUsersByCafeteriaId(item.diner));
        }
    }, [item.diner]);

    // Load menu details by ID and populate state
    useEffect(() => {
        let menuId = id || cloneId;
        if (menuId) {
            dispatch(GetMenuById(menuId)).then(
                ({
                    payload: {
                        data: { data },
                    },
                }) => {

                    if (data?.id) {
                        if (cloneId) {
                            setItem(MENU_MODEL.setToClone(data));
                            setSelectedDepartment([]);
                            setSelectedName([]);
                        } else {
                            setItem(MENU_MODEL.set(data));
                            setSelectedDepartment(
                                data?.departments?.map((e) => ({
                                    id: e.departmentId,
                                    label: e.departmentName,
                                    unit: formatTimeUnit(e.availableAfterMinutes),
                                    subtitle: t('after').toLowerCase(),
                                    time: parseInt(e.availableAfterMinutes),
                                })),
                            );
                            setSelectedName(
                                data?.users?.map((e) => ({
                                    id: e.id,
                                    label: e.name,
                                })),
                            );
                        }
                        
                        setSelectedMealTime(
                            data?.foodieMealTimeStocks?.map((e) => ({
                                id: e.mealTimeId,
                                label: e.mealTimeName,
                                unit: e.stock,
                                subtitle: t('units').toLowerCase(),
                            })),
                        );
                    }
                    setDataComplete(true);
                },
            );
        }
    }, [deleteItem, updateItem, id, cloneId]);

    useEffect(() => {
        if (dataComplete) {
            setEmptyMealTime(!(Array.isArray(selectedMealTime) && selectedMealTime.length > 0));
        }
    }, [selectedMealTime, dataComplete]);

    /**
     * Validates the value entered in the cost input field.
     * If the cost is a base cost, no validation is applied.
     * Allows empty values and checks that the value is numeric and greater than zero.
     *
     * @param {Event} e Input event containing the value to be validated.
     */
    const validateCost = () => {
        if(!showCostInfo) return;
        const rawValue = item?.cost?.toString() || '';
        if (!DECIMAL_REGEX.test(rawValue)) {
            setIsValidCostText('invalid_format');
            setIsValidCost(false);
            return;
        }
        const value = Number(rawValue);
        setIsValidCostText('this_value_must_be_greater_than_0');
        setIsValidCost(!isNaN(value) && value > MIN_MEAL_COST.min);
    };

    // Handles updating the menu
    const handleUpdate = () => {
        const deptVal = department.validate({ selectedDepartment });
        const mealVal = mealTime.validate({ selectedMealTime });
        if (selectedMealTime.length === 0) {
            setEmptyFields(true);
            toast.warning(t('please_fill_all_fields'));
            return;
        }
        setUpdate(true);

        if (deptVal.showToast || mealVal.showToast) return;

        const isOverallEmpty =
            !item.isValidAvailability() || !isServingDateValid || deptVal.isEmpty || mealVal.isEmpty || !isValidCost;

        if (!item.isValid(showCostInfo) || isOverallEmpty) {
            setEmptyFields(true);
            toast.warning(t('please_fill_all_fields'));
            return;
        }

        let aux = {
            ...item,
            releaseHour:
                item.releaseHour != null
                    ? typeof item.releaseHour === 'number'
                        ? item.releaseHour
                        : Number(toMilitaryHour(item.releaseHour))
                    : item.releaseHour,
            userIds: selectedName.map((item) => item.id),
            departments: selectedDepartment.map((dept) => ({
                departmentId: dept.id,
                availableAfterMinutes: parseInt(dept.time, 10),
            })),
            foodieMealTimeIds: selectedMealTime.map((item) => ({
                mealTimeId: item.id,
                stock: item.unit,
            }))
        };

        let body = aux.toRegister();
        if (cloneId) {
            handleClone(body);
            return;
        }

        dispatch(UpdateMenu(body)).then(
            ({
                payload: {
                    data: { data, code },
                },
            }) => {
                if (data.id) {
                    toast.success(t('has_been_updated_successfully'));
                    setUpdateItem(true);
                } else errorMsg(code);
            },
        );
    };

    const handleClone = (body) => {
        dispatch(CreateMenu(body)).then(
            ({
                payload: {
                    data: { data, code },
                },
            }) => {
                if (data.id) {
                    toast.success(t('has_been_cloned_successfully'));
                    goBack();
                } else errorMsg(code);
            },
        );
    };

    /**
     * @function handleLocalDelete
     * @description
     * Removes an element from a specific array property within the `item` state.
     * This function is used to locally update arrays (e.g., userIds, departments, etc.)
     * by filtering out the element with the matching `id`.
     *
     * @param {string} arrayKey - The key name of the array property to update within the state object.
     * @param {{ id: string | number }} element - The element to remove, identified by its `id` property.
     *
     * @example
     * // Removes a department from the departments array
     * handleLocalDelete("TO_CLONE_ARRAYS.MEALTIMES", { id: 3 });
     *
     * // Removes a user from the userIds array
     * handleLocalDelete("TO_CLONE_ARRAYS.DEPARTMENTS", { id: "abc123" });
     */

    const handleLocalDelete = (arrayKey, element) => {
        setItem((prev) => ({
            ...prev,
            [arrayKey]: prev[arrayKey]?.filter((el) => el.id !== element.id),
        }));
    };

    // Handles deletion of a meal time by dispatching the corresponding action
    const handleMealTimeDelete = async (element) => {
        if(cloneId){
            handleLocalDelete(TO_CLONE_ARRAYS.MEALTIMES, element)
            return
        }
        return dispatch(
            DeleteMealTimeById({
                foodieMenuId: id,
                mealTimeId: element.id,
            }),
        ).then(({ payload }) => {
            const { code, success } = payload?.data || {};
            if (success) {
                setDeleteItem(true);
            } else {
                errorMsg(code);
            }
        });
    };


    // Handles deletion of a user by dispatching the corresponding action
    const handleUserDelete = async (element) => {
        if (cloneId) {
            handleLocalDelete(TO_CLONE_ARRAYS.USERS, element)
            return
        }
        return dispatch(
            DeleteUserById({
                foodieMenuId: id,
                userId: element.id,
            }),
        ).then(({ payload }) => {
            const { code, success } = payload?.data || {};
            if (!success) {
                errorMsg(code);
            }
        });
    };

    // Handles deletion of a department by dispatching the corresponding action
    const handleDepartmentDelete = (element) => {
        if (cloneId) {
            handleLocalDelete(TO_CLONE_ARRAYS.DEPARTMENTS, element)
            return
        }
        return dispatch(
            DeleteDepartmentById({
                foodieMenuId: id,
                departmentId: element.id,
            }),
        ).then(({ payload }) => {
            const { code, success } = payload?.data || {};
          if (!success) {
            errorMsg(code);
          }
        });
    };

    /**
     * Handles navigation to the previous page or a default route.
     */
    const goBack = () => {
        if(state?.backUrl){
            navigate(state.backUrl.pathname, {
                state: {...state?.backUrl?.state}
            });
        } else {
            navigate(routes.foodie.list, { state: {cloneId: null}})
        }
    }

    return {
        t,
        navigate,
        DEV,
        cloneId,
        item,
        permission,
        disabled,
        emptyFields,
        handleChange,
        handleUpdate,
        selectedName,
        setSelectedName,
        selectedDepartment,
        setSelectedDepartment,
        allMeals,
        allCafeterias,
        allItem,
        selectedMealTime,
        setSelectedMealTime,
        handleMealTimeDelete,
        handleUserDelete,
        handleDepartmentDelete,
        allCourseType,
        emptyMealTime,
        emptyDepartment,
        goBack,
        isServingDateValid,
        departments: getDepartmentsByCafeteriaId.map((i) => ({
            id: i.id,
            label: i.name,
            subtitle: 'after',
        })),
        users: getUsersByCafeteriaId.map((i) => ({
            id: i.id,
            label: i.name,
        })),
        mealTime: Array.isArray(allMealTimes)
            ? allMealTimes.map((i) => ({
                  id: i.id,
                  label: i.label,
                  subtitle: 'units',
              }))
            : [],

        department,
        setDepartment,
        isValidCost,
        isValidCostText,
        validateCost,
        setMealTime,
        showCostInfo
    };
};

export default UpdateMenuApp;
